import { render, staticRenderFns } from "./NoticiasFlash.vue?vue&type=template&id=579030f9&scoped=true&"
import script from "./NoticiasFlash.vue?vue&type=script&lang=js&"
export * from "./NoticiasFlash.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasFlash.vue?vue&type=style&index=0&id=579030f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579030f9",
  null
  
)

export default component.exports